export default function TimeLocationFactory(defaultTimeFactory) {
    'ngInject';

        const timeOptions = defaultTimeFactory.getTimeOptions();
        const defaultTime = defaultTimeFactory.getDefaultTime();
        const formats = defaultTimeFactory.defaultFormats;

        function TimeLocation() {
            this.location = {
                address: null,
                altAddress: null,
                latitude: null,
                longitude: null,
            };

            this.date = {
                value: null,
                pickerSettings: null,
            };

            this.time = {
                options: timeOptions,
                current: angular.copy(defaultTime),
                default: angular.copy(defaultTime),
                previous: null,
            };

        }

        TimeLocation.prototype.setDateTime = function(dateTime, noFormat) {
            const momnt1 = noFormat ? moment(dateTime) : moment(dateTime, formats.date);
            const momnt2 = noFormat ? momnt1 : moment(dateTime, formats.dateTime);
            const minutes = momnt2.hour() * 60 + momnt2.minute();

            this.date.value = momnt1.format(formats.date);
            this.time.current = angular.copy(_.find(timeOptions, {value: minutes}));
            this.time.previous = angular.copy(this.time.current);
        };

        TimeLocation.prototype.getDateTime = function() {
            return moment(this.date.value, formats.date).add({minutes: this.time.current.value});
        };

        TimeLocation.prototype.getAltFormatted = function() {
            return this.getDateTime().format(formats.altDateTime);
        };

        TimeLocation.prototype.clearLocation = function() {
            this.location = {
                address: null,
                altAddress: null,
                latitude: null,
                longitude: null,
            };
        };

        return TimeLocation;
}



// WEBPACK FOOTER //
// ./src/app/modules/cars/services/timeLocationConstructor.js